module.exports = __webpack_public_path__ + "img/re_file_up_1.a553158f.png";